import axios from "axios";

export const fetchProvisioningStatus = async (serialList, accessToken) => {
    const trimSerialList = serialList.replace(/\s/g, '');
    const data = { serialList: trimSerialList }
    console.log("payload", data);
    try {
      const response = await axios.post(`${process.env.REACT_APP_INFINITY_ADMIN_BASE_URL}/systems/provisioning-status`, data, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': accessToken
        }
      });
      return response.data;
    } catch (e) {
      console.log("errored out!!!")
    }
 }
 
 export const getMacPin = async (serial, accessToken) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_INFINITY_ADMIN_BASE_URL}/systems/get-mac-pin`,
      { serial },
      {
        headers: {
          Authorization: accessToken,
          "Content-Type": "application/json",
          operation: "invalid_mac_pin",
        },
      },
    );
    return response.data;
  } catch (e) {
    console.log("errored out!!!", e.message);
  }
};

export const setMacPin = async (serial, mac, pin, accessToken) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_INFINITY_ADMIN_BASE_URL}/systems/set-mac-pin`,
      { serial, mac, pin },
      {
        headers: {
          Authorization: accessToken,
          "Content-Type": "application/json",
          operation: "invalid_mac_pin",
        },
      },
    );
    return response.data;
  } catch (e) {
    console.log("errored out!!!");
  }
};

export const provisionDeviceAPI = async (serial, accessToken) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_INFINITY_ADMIN_BASE_URL}/systems/provision-wall-controller`,
      { serial },
      {
        headers: {
          Authorization: accessToken,
          "Content-Type": "application/json",
          operation: "provisioning_b_type",
        },
      },
    );
    return response.data;
  } catch (e) {
    console.log("errored out!!!");
  }
};
